var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconStatistics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 46,
    viewBox: "0 0 51 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_168357",
    "data-name": "Group 168357",
    transform: "translate(-891 -16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_148240",
    "data-name": "Rectangle 148240",
    transform: "translate(891 16)",
    fill: "none",
    stroke: "#ff9131",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 46,
    rx: 23,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 50,
    height: 45,
    rx: 22.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chart-line",
    "data-name": "Icon awesome-chart-line",
    d: "M24.542,20.333H3.167V5.292A.791.791,0,0,0,2.375,4.5H.792A.791.791,0,0,0,0,5.292V21.917A1.584,1.584,0,0,0,1.583,23.5H24.542a.791.791,0,0,0,.792-.792V21.125A.791.791,0,0,0,24.542,20.333ZM22.958,6.083H17.117a1.187,1.187,0,0,0-.84,2.027l1.6,1.6-3.63,3.631-3.63-3.63a1.583,1.583,0,0,0-2.239,0l-3.4,3.4a.792.792,0,0,0,0,1.12L6.1,15.352a.792.792,0,0,0,1.12,0L9.5,13.072l3.63,3.63a1.583,1.583,0,0,0,2.239,0l4.75-4.75,1.6,1.6a1.187,1.187,0,0,0,2.027-.84V6.875A.791.791,0,0,0,22.958,6.083Z",
    transform: "translate(903.833 25)",
    fill: "#ff9131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatistics);
export default __webpack_public_path__ + "static/media/Icon-statistics.8fd5a746058aadafe5705c91ae295069.svg";
export { ForwardRef as ReactComponent };